/**
 * Armenian Belot (auction/bazar) — fixed suit precedence when bid levels are equal.
 * Higher numeric strength = stronger bid for tie-breaking (package B).
 *
 * Indices match {@link ./types} suit constants: clubs=0, diamonds=1, hearts=2, spades=3.
 *
 * @module game/belot/armenian/constants
 */

/** @readonly */
const AUCTION_SUIT_STRENGTH = Object.freeze(
  /** @type {readonly [number, number, number, number]} */ ([
    0, 1, 2, 3,
  ]),
);

/**
 * `no_trump` / sans-atout contract type strength when comparing at the same bid level.
 * Must be strictly above any suited bid at the same level (package B).
 * @readonly
 */
const AUCTION_NO_TRUMP_STRENGTH = 4;
/**
 * `all_trump` contract is strongest on equal bid level.
 * @readonly
 */
const AUCTION_ALL_TRUMP_STRENGTH = 5;

module.exports = {
  AUCTION_SUIT_STRENGTH,
  AUCTION_NO_TRUMP_STRENGTH,
  AUCTION_ALL_TRUMP_STRENGTH,
};
